import moment from "moment";
import store from "../store";

export const getDefaultConfig = (format, minDate, maxDate) => {
    format = format || getDefaultFormat()
    return {
        format: format,
        icons: {
            time: 'os-icon os-icon-calendar-time',
            date: 'os-icon os-icon-basic-2-259-calendar',
            up: 'os-icon os-icon-chevron-up',
            down: 'os-icon os-icon-chevron-down',
            previous: 'os-icon os-icon-chevron-left',
            next: 'os-icon os-icon-chevron-right',
            clear: 'os-icon os-icon-trash',
            close: 'os-icon os-icon-cancel-circle'
        },
        minDate: minDate || getDefaultMinDate(format),
        maxDate: maxDate || getDefaultMaxDate(format),
        showClear: true
    };
}

export const getDefaultMinDate = (format) => moment(new Date('1979-01-01'), format);

export const getDefaultMaxDate = (format) => moment(new Date(), format);

export const getDefaultFormat = () => {
    console.log(store.getters.allTemplateDetails.datePickerFormat)
    if(store.getters.allTemplateDetails && store.getters.allTemplateDetails.datePickerFormat) {
        return store.getters.allTemplateDetails.datePickerFormat.replace(/-/g, '/')
    } else {
        return "MM/DD/YYYY"
    }
}
